export default __webpack_public_path__ + "static/media/AGC_2022_R2_QP_Class_5.f258d8f6.pdf";